@if (!isSettingsView()) {
<p-panelmenu [model]="mainMenuItems()" class="w-full md:w-80 !p-0" styleClass="!p-0 !gap-0">
  <ng-template #item2 let-item2>
      <a class="flex items-center px-4 py-2 cursor-pointer group {{ isActiveRoute(item2.routerLink) ? 'active-link' : '' }}">
          <i [class]="item2.icon + ' text-primary group-hover:text-inherit'"></i>
          <span class="ml-2">
              {{ item2.label }}
          </span>
      </a>
  </ng-template>
</p-panelmenu>
} @else {
  <app-sidebar-settings [settingsItems]="settingsMenuItems()"></app-sidebar-settings>
}